export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageSlider.vue?vue&type=template&id=3f5477ef&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ImageSlider.vue?vue&type=template&id=3f5477ef&scoped=true&
// module id = 160
// module chunks = 0